import { PageHeader } from "components/ui";
import React from "react";
import { Grid, Typography, Box } from "@mui/material";
import CustomButton from "components/buttonsComponent/StyledButton";
import NavigationButtons from "helper/navigation/NavigationButtons";
import DownloadZipButton from "components/buttonsComponent/DownloadZipButton";

const WhatareEP = () => {
  const urlConfig = {
    name: "EP.zip",
    downloadUrl: "https://demo.sustainesg.ca/pdf/EP.zip",
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <PageHeader title="AI-Powered ESG Reporting across Global, National, Sectoral, and Industry-Specific Standards" />
        </Box>
      </Grid>

      <Grid item xs={12}>
        <Box className="gri-header">
          <NavigationButtons
            imageKey="Equator Principles"
            title={"EP Reporting"}
            activeStep={0}
          />
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Box
          sx={{
            borderRadius: "8px",
            padding: "24px",
            top: "226px",
            left: "75px",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              color: "#2E7D32",
              mb: 3,
              fontFamily: "DM Sans",
              fontSize: "40px",
              lineHeight: "38px",
            }}
          >
            The global standards for sustainability
            <br /> impacts
          </Typography>

          <Box sx={{ mb: 2 }}>
            <Typography
              component="h4"
              sx={{
                fontFamily: "DM Sans",
                fontWeight: 800,
                fontSize: "20px",
                lineHeight: "28px",
                letterSpacing: "-2%",
                color: "#4F4F4F",
                mb: 1,
              }}
            >
              What are the Equator Principles?
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: "DM Sans",
                fontWeight: 400,
                fontSize: "20px",
                lineHeight: "28px",
                letterSpacing: "-2%",
                color: "#4F4F4F",
                mb: 2,
              }}
            >
              The Equator Principles (EPs) are a comprehensive set of
              internationally recognized, voluntary standards designed to help
              financial institutions identify, assess, and manage environmental
              and social risks associated with financing large-scale development
              projects.
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: "DM Sans",
                fontWeight: 400,
                fontSize: "20px",
                lineHeight: "28px",
                letterSpacing: "-2%",
                color: "#4F4F4F",
                mb: 2,
              }}
            >
              Established in 2003, the Equator Principles provide a risk
              management framework specifically for project finance,
              project-related corporate loans, bridge loans, and project-related
              advisory services, particularly for projects where total capital
              costs exceed USD 10 million. These principles guide financial
              institutions in ensuring that the projects they finance are
              developed in a socially responsible manner and reflect sound
              environmental management practices.
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: "DM Sans",
                fontWeight: 400,
                fontSize: "20px",
                lineHeight: "28px",
                letterSpacing: "-2%",
                color: "#4F4F4F",
                mb: 2,
              }}
            >
              The EPs align closely with the International Finance Corporation
              (IFC) Performance Standards on Environmental and Social
              Sustainability and the World Bank Group Environmental, Health, and
              Safety (EHS) Guidelines. They set a common baseline and minimum
              standards for due diligence and monitoring to support sustainable
              project outcomes.
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: "DM Sans",
                fontWeight: 400,
                fontSize: "20px",
                lineHeight: "28px",
                letterSpacing: "-2%",
                color: "#4F4F4F",
                mb: 2,
              }}
            >
              Specifically, the Equator Principles require borrowers and clients
              to conduct detailed Environmental and Social Impact Assessments
              (ESIA), develop robust Environmental and Social Management Systems
              (ESMS), engage with affected communities and stakeholders,
              establish grievance mechanisms, assess climate change-related
              risks, and disclose key project information transparently.
              Financial institutions adopting the EPs commit to applying these
              standards across all applicable transactions, regardless of the
              sector or geographic location.
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: "DM Sans",
                fontWeight: 400,
                fontSize: "20px",
                lineHeight: "28px",
                letterSpacing: "-2%",
                color: "#4F4F4F",
                mb: 2,
              }}
            >
              There are ten (10) Equator Principles that cover a range of
              topics, including:
            </Typography>
            <Box component="ul" sx={{ pl: 4, mb: 2 }}>
              <Typography
                component="li"
                sx={{
                  fontFamily: "DM Sans",
                  fontWeight: 400,
                  fontSize: "20px",
                  lineHeight: "28px",
                  letterSpacing: "-2%",
                  color: "#4F4F4F",
                }}
              >
                Review and categorization of project risks
              </Typography>
              <Typography
                component="li"
                sx={{
                  fontFamily: "DM Sans",
                  fontWeight: 400,
                  fontSize: "20px",
                  lineHeight: "28px",
                  letterSpacing: "-2%",
                  color: "#4F4F4F",
                }}
              >
                Conducting environmental and social assessments
              </Typography>
              <Typography
                component="li"
                sx={{
                  fontFamily: "DM Sans",
                  fontWeight: 400,
                  fontSize: "20px",
                  lineHeight: "28px",
                  letterSpacing: "-2%",
                  color: "#4F4F4F",
                }}
              >
                Compliance with applicable environmental and social standards
              </Typography>
              <Typography
                component="li"
                sx={{
                  fontFamily: "DM Sans",
                  fontWeight: 400,
                  fontSize: "20px",
                  lineHeight: "28px",
                  letterSpacing: "-2%",
                  color: "#4F4F4F",
                }}
              >
                Establishment of action plans and management systems
              </Typography>
              <Typography
                component="li"
                sx={{
                  fontFamily: "DM Sans",
                  fontWeight: 400,
                  fontSize: "20px",
                  lineHeight: "28px",
                  letterSpacing: "-2%",
                  color: "#4F4F4F",
                }}
              >
                Demonstrating stakeholder engagement
              </Typography>
              <Typography
                component="li"
                sx={{
                  fontFamily: "DM Sans",
                  fontWeight: 400,
                  fontSize: "20px",
                  lineHeight: "28px",
                  letterSpacing: "-2%",
                  color: "#4F4F4F",
                }}
              >
                Ensuring grievance mechanisms
              </Typography>
              <Typography
                component="li"
                sx={{
                  fontFamily: "DM Sans",
                  fontWeight: 400,
                  fontSize: "20px",
                  lineHeight: "28px",
                  letterSpacing: "-2%",
                  color: "#4F4F4F",
                }}
              >
                Evaluating independent review processes
              </Typography>
              <Typography
                component="li"
                sx={{
                  fontFamily: "DM Sans",
                  fontWeight: 400,
                  fontSize: "20px",
                  lineHeight: "28px",
                  letterSpacing: "-2%",
                  color: "#4F4F4F",
                }}
              >
                Monitoring and reporting requirements
              </Typography>
              <Typography
                component="li"
                sx={{
                  fontFamily: "DM Sans",
                  fontWeight: 400,
                  fontSize: "20px",
                  lineHeight: "28px",
                  letterSpacing: "-2%",
                  color: "#4F4F4F",
                }}
              >
                Addressing climate change risks
              </Typography>
              <Typography
                component="li"
                sx={{
                  fontFamily: "DM Sans",
                  fontWeight: 400,
                  fontSize: "20px",
                  lineHeight: "28px",
                  letterSpacing: "-2%",
                  color: "#4F4F4F",
                }}
              >
                Transparency and public reporting
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {/* <a
            href="https://equator-principles.com/app/uploads/The-Equator-Principles_EP4_July2020.pdf"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none" }}
          >
            <CustomButton title="Access to full Equator Principles Documents" />
          </a> */}

          <DownloadZipButton
            config={urlConfig}
            title="Access to full Equator Principles Documents"
            externalHref="https://equator-principles.com/app/uploads/The-Equator-Principles_EP4_July2020.pdf"
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default WhatareEP;
